<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <div class="weui-cell" slot="tar_decode">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.tar_decode || "需求单号"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.tar_decode }}
          </div>
        </div>
        <div class="weui-cell" slot="de_name">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.de_name || "项目名称"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.de_name }}
          </div>
        </div>
        <div class="weui-cell" slot="de_custname">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.de_custname || "需求来源"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.de_custname }}
          </div>
        </div>
        <div class="weui-cell" slot="de_product_type">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.de_product_type || "产品类型"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.de_product_type }}
          </div>
        </div>
        <div class="weui-cell" slot="de_emname">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.de_emname || "需求人"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.de_emname }}
          </div>
        </div>
        <div class="weui-cell" slot="de_dpname">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.de_dpname || "需求部门"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.de_dpname }}
          </div>
        </div>
        <div class="weui-cell" slot="tar_project_classify">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.tar_project_classify || "项目分类"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.tar_project_classify"
              placeholder="请选择"
            >
              <option>销售立项</option>
              <option>产品立项</option>
              <option>技术立项</option>
            </select>
          </div>
        </div>
        <div class="weui-cell" slot="tar_project_level">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.tar_project_level || "项目等级"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.tar_project_level"
              placeholder="请选择"
            >
              <option>高</option>
              <option>中</option>
              <option>低</option>
            </select>
          </div>
        </div>
        <employee-field
          :label="customLabel.tar_emname || '项目负责人'"
          v-model="form.main.tar_emname"
          @select="onSelectEmployee"
          slot="tar_emname"
        />

        <div class="weui-cell" slot="tar_budget">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.tar_budget || "项目预算金额"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.tar_budget"
              placeholder="请输入"
            />
          </div>
        </div>
        <currency-field
          slot="tar_currency"
          :label="customLabel.tar_currency || '币种'"
          v-model="form.main.tar_currency"
        />
        <div class="weui-cell" slot="tar_function_match_degree">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.tar_function_match_degree || "功能要求匹配度"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.tar_function_match_degree"
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="weui-cell" slot="tar_performance_conformity">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.tar_performance_conformity || "性能要求符合度"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.tar_performance_conformity"
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="weui-cell" slot="tar_compatibility">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.tar_compatibility || "兼容性"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.tar_compatibility"
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="weui-cell" slot="tar_team_capacity">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.tar_team_capacity || "团队技术能力"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.tar_team_capacity"
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="weui-cell" slot="tar_technical_risk">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.tar_technical_risk || "技术风险分析"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <textarea
              class="weui-textarea"
              rows="5"
              autofocus
              v-model="form.main.tar_technical_risk"
              placeholder="请输入技术风险分析"
              placeholder-class="weui-input__placeholder"
            />
          </div>
        </div>
        <div class="weui-cell" slot="tar_develop_period">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.tar_develop_period || "开发周期"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <textarea
              class="weui-textarea"
              rows="5"
              autofocus
              v-model="form.main.tar_develop_period"
              placeholder="请输入开发周期"
              placeholder-class="weui-input__placeholder"
            />
          </div>
        </div>
        <div class="weui-cell" slot="tar_feasibility_assess">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.tar_feasibility_assess || "技术可行性评估结论"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <textarea
              class="weui-textarea"
              rows="5"
              autofocus
              v-model="form.main.tar_feasibility_assess"
              placeholder="请输入技术可行性评估结论"
              placeholder-class="weui-input__placeholder"
            />
          </div>
        </div>
      </custom-layout>

      <div class="weui-cells__group">
        <div class="weui-cells">
          <file-field v-model="form.main.mar_attach" />
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import CurrencyField from "@/components/field/CurrencyField.vue";
import FileField from "@/components/field/FileField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    EmployeeField,
    CurrencyField,
    FileField,
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/plm/technicalAnalyseReport",
      codeField: "tar_code",
      statusField: "tar_statuscode",
      caller: "TechnicalAnalyseReport",
      xtype: "plm-technicalanalysereport-formpanel",
      form: {
        main: {
          tar_deid: null,
          tar_decode: null,
          de_name: null,
          de_custid: null,
          de_custcode: null,
          de_custname: null,
          de_product_type: null,
          de_emname: null,
          de_dpname: null,
          tar_project_classify: null,
          tar_project_level: null,
          tar_emname: null,
          tar_emcode: null,
          tar_emid:null,
          tar_budget:null,
          tar_currency:null,
          tar_function_match_degree:null,
          tar_performance_conformity:null,
          tar_compatibility:null,
          tar_team_capacity:null,
          tar_technical_risk:null,
          tar_develop_period:null,
          tar_feasibility_assess:null,
          tar_attach:null,
        },
      },
    };
  },
  methods: {
    onSelectEmployee(selection) {
      var me = this,
        main = me.form.main;
      main.tar_emid = selection.id;
      main.tar_emcode = selection.em_code;
    },

    /**
     * 保存
     */
    save() {
      var me = this;
      me.p_save();
    },
  },
};
</script>
